<template>
  <svg
    class="icon"
    width="20"
    height="26"
    viewBox="0 0 20 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M10.5427 0.942487C10.2233 0.68655 9.76829 0.68655 9.44893 0.942487C9.12519 1.23999 0.375244 8.29249 0.375244 15.6251C0.375244 19.0638 2.20947 22.2412 5.18788 23.9607C8.1663 25.6802 11.8345 25.6801 14.8129 23.9607C17.7912 22.2414 19.6255 19.0641 19.6255 15.6251C19.6255 8.29249 10.8755 1.24013 10.5429 0.942487H10.5427ZM10.0002 21.7498C8.37594 21.7498 6.8174 21.1045 5.66884 19.9561C4.52028 18.8077 3.8751 17.2491 3.8751 15.6248C3.8751 15.1413 4.26666 14.7498 4.7501 14.7498C5.23355 14.7498 5.6251 15.1413 5.6251 15.6248C5.6251 16.7852 6.08556 17.8976 6.90697 18.718C7.72729 19.5394 8.83962 19.9998 10.0001 19.9998C10.4836 19.9998 10.8751 20.3914 10.8751 20.8748C10.8751 21.3583 10.4836 21.7498 10.0001 21.7498L10.0002 21.7498Z" />
  </svg>
</template>

<script>
export default {
  name: 'Drop',
};
</script>
